import { Link } from '@tanstack/react-router';
import {
  Laptop,
  LinkIcon,
  LogOut,
  Menu,
  Moon,
  Palette,
  Settings,
  Sun,
  User,
} from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { useAuthenticatedUser } from '@/components/providers/AuthenticatedUserProvider';
import { useTheme } from '@/components/providers/ThemeProvider';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export const Dropdown = (): JSX.Element => {
  const { setTheme } = useTheme();
  const { signOut } = useAuthenticatedUser();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Menu width={50} height={50} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuLabel>
          <FormattedMessage id="global.menu.settings" />
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <Link to="/my-profile">
            <DropdownMenuItem>
              <User className="mr-2 h-4 w-4" />
              <span>
                <FormattedMessage id="global.menu.myProfile" />
              </span>
            </DropdownMenuItem>
          </Link>
          <Link to="/configuration">
            <DropdownMenuItem>
              <Settings className="mr-2 h-4 w-4" />
              <span>
                <FormattedMessage id="global.menu.configuration" />
              </span>
            </DropdownMenuItem>
          </Link>
          <Link to="/integrations">
            <DropdownMenuItem>
              <LinkIcon className="mr-2 h-4 w-4" />
              <span>
                <FormattedMessage id="global.menu.integrations" />
              </span>
            </DropdownMenuItem>
          </Link>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <Palette className="mr-2 h-4 w-4" />
            <span>
              <FormattedMessage id="global.menu.themeSettings.title" />
            </span>
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              <DropdownMenuItem onClick={() => setTheme('dark')}>
                <Moon className="mr-2 h-4 w-4" />
                <span>
                  <FormattedMessage id="global.menu.themeSettings.dark" />
                </span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setTheme('light')}>
                <Sun className="mr-2 h-4 w-4" />
                <span>
                  <FormattedMessage id="global.menu.themeSettings.light" />
                </span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => setTheme('system')}>
                <Laptop className="mr-2 h-4 w-4" />
                <span>
                  <FormattedMessage id="global.menu.themeSettings.system" />
                </span>
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={signOut}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>
            <FormattedMessage id="global.menu.signOut" />
          </span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
